<template>
  <div>
    <b-col
      v-if="errorExists"
      md="12"
      class="error-box">
      <img
        class="error-box__icon"
        src="~@/assets/img/error-type-1.svg"
        alt="Error icon">
      <div v-if="validationError">
        <h2 class="error-box__title">Validation Error.</h2>
        <h3
          v-for="(error, i) in errorList"
          :key="i"
          class="error-box__subtitle">
          {{ error[0] }}
        </h3>
      </div>
      <div v-else>
        <h2 class="title">{{ errorMessage }}</h2>
      </div>
    </b-col>
    <b-col
      v-else-if="showErrorp"
      md="12"
      class="error-box">
      <img
        class="error-box__icon"
        src="~@/assets/img/error-type-1.svg"
        alt="Error icon">
      <h2 class="error-box__title">
        <slot name="header">Error!</slot>
      </h2>
      <h3 class="error-box__subtitle">
        <slot name="text">Something Went wrong!</slot>
      </h3>
      <div class="error-box__more">
        <slot name="more"/>
      </div>
    </b-col>
  </div>
</template>

<script>
export default {
  name: 'ErrorBox',
  props: {
    errorp: {
      type: Object,
      default: () => {},
    },
    showErrorp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorMessage: '',
      errorList: '',
      validationError: false,
    };
  },
  computed: {
    errorExists() {
      return !this.$lodash.isEmpty(this.errorp);
    },
  },
  watch: {
    errorp(error) {
      if (!this.$lodash.isEmpty(error)) {
        if (error.status === 422) {
          this.validationError = true;
          this.errorList = error.data.errors;
        } else {
          this.errorMessage = error.data.message;
        }
      }
    },
  },
};
</script>
